var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 64h-64V8C336 3.578 332.4 0 328 0S320 3.578 320 8V64H128V8C128 3.578 124.4 0 120 0S112 3.578 112 8V64h-64C21.5 64 0 85.5 0 112v352C0 490.5 21.5 512 48 512h352c26.5 0 48-21.5 48-48v-352C448 85.5 426.5 64 400 64zM432 464c0 17.64-14.36 32-32 32h-352c-17.64 0-32-14.36-32-32v-256h416V464zM432 192h-416V112c0-17.64 14.36-32 32-32h64V128c0 4.422 3.594 8 8 8S128 132.4 128 128V80h192V128c0 4.422 3.594 8 8 8S336 132.4 336 128V80h64c17.64 0 32 14.36 32 32V192zM96 384h64c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32H96C78.33 256 64 270.3 64 288v64C64 369.7 78.33 384 96 384zM80 288c0-8.822 7.178-16 16-16h64c8.822 0 16 7.178 16 16v64c0 8.822-7.178 16-16 16H96c-8.822 0-16-7.178-16-16V288z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarday);
export default __webpack_public_path__ + "static/media/calendarday.7dfba67110d49487bf2926971d66e8bb.svg";
export { ForwardRef as ReactComponent };